import React from "react";
import { Dialog, Classes } from "@blueprintjs/core";
import {useTranslation} from "react-i18next";

// Components
import Button from "../common/components/button";

// Actions
import {updateClientStatus} from "./clients-actions";
import {useDispatch} from "react-redux";

// Redux dispatch hook
const useReduxDispatch = () => {
    const dispatch = useDispatch();
    return {
        updateClientStatus: (client) => dispatch(updateClientStatus(client))
    }
};

const DeactivateClientDialog = (props) => {
    const {isOpen, onClose, client} = props;
    const {name, nif} = client;

    // Redux
    const {updateClientStatus} = useReduxDispatch();

    // i18n
    const {t} = useTranslation("clients");

    return (
        <Dialog
            isOpen={isOpen}
            onClose={onClose}
            lazy={true}
            style={{
                backgroundColor: "white",
                paddingBottom: "40px"
            }}
        >
            <div
                style={{margin: "20px 40px"}}
                className={Classes.DIALOG_BODY}
            >
                <h3 style={{margin: "20px 0"}}>{t("deactivateClientDialog.title")}</h3>
                <h4 style={textStyle}>{name}</h4>
                <p>
                    {t("deactivateClientDialog.sap")} <b>{client.sap_id}</b><br/>
                    {t("deactivateClientDialog.nif")} <b>{nif}</b>
                </p>
                <p>{t("deactivateClientDialog.text1")}</p>
                <p>{t("deactivateClientDialog.text2")}</p>
            </div>
            <div
                style={{margin: "20px 40px 0 40px"}}
                className={Classes.DIALOG_FOOTER}>
                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                    <Button
                        text={t("editClientDialog.input.cancel")}
                        action={onClose}
                        intent={"cancel"}
                        style={{
                            marginRight: "15px",
                        }}
                    />
                    <Button
                        text={t("deactivateClientDialog.deactivate")}
                        action={() => {
                            let status = "inactive";
                            updateClientStatus({_id: client._id, status: status, clientId: client._id});
                            onClose();
                        }}
                        intent={"primary"}
                    />
                </div>
            </div>
        </Dialog>
    );
};

export default DeactivateClientDialog;

const textStyle = {
    color: "#4796cb"
};